import {SET_CAROUSEL_ITEMS} from 'actions/types';


var carouselItemsInitialState = {
        items:[], 
        loaded:false, 
        indexed:{}
    };
export default (state = carouselItemsInitialState, action) => {
    switch(action.type) {
        case SET_CAROUSEL_ITEMS: 
            return {...state,
                    items:action.carouselItems || [],
                    loaded:true
                    };
        default:            
            return state;
    }
}

//selectors
export const isCarouselLoaded  = state => state.loaded;
export const getCarouselItems = state => state.items;



// WEBPACK FOOTER //
// ./src/reducers/carouselItems.js